import { useChat } from '../chat/ChatProvider';
import { WorkgroupManagement } from '../chat/WorkgroupManagement';
import { chatRequest } from '../../service/ChatService';
export const managementRequest = (path, method = 'GET', body, signal) =>
  chatRequest(path, { method, body, signal });
export default function ChatSettings() {
  const { currentUser, error, refreshDirectory } = useChat();
  if (!currentUser)
    return (
      <div className="wg-status" role={error ? 'alert' : 'status'}>
        {error?.message || 'Loading workgroup management…'}
        {error ? <button onClick={() => void refreshDirectory()}>Retry</button> : null}
      </div>
    );
  if (currentUser.role?.toUpperCase() !== 'ADMIN')
    return (
      <div className="wg-status" role="alert">
        Workgroup management is available to administrators.
      </div>
    );
  return <WorkgroupManagement request={managementRequest} user={currentUser} />;
}
